import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import CGMGuideImage from "src/assets/images/cgm/connection-journey/cgm-guide.webp";
import Button from "src/components/app/Button";

const CGMConnectionGuide: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const supportProgramKey = params["support-program-key"] ?? "";
  return (
    <div className="relative pt-4">
      <div className="flex items-center justify-between">
        <img
          src={CGMGuideImage}
          alt="CGM Transmitter and Sensor"
          className="object-contain"
        />
        <div
          className="flex items-center gap-2 absolute left-8"
          style={{ bottom: "20px" }}
        >
          <Button
            variant="contained"
            rounded="full"
            fullWidth
            onClick={() => {
              navigate(`/app/${supportProgramKey}/cgm-connect-guide`);
            }}
          >
            Open CGM Guide
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CGMConnectionGuide;
